<template>
  <div>
    <div
      class="search_result company_search_result"
      :key="'company_' + company.id"
      v-for="company in results"
    >
      <div dir="ltr" class="is-flex is-align-items-center is-justify-content-flex-end">
        <b>Company: (ID: {{ company.id }})&nbsp;</b>
        <link-entity
          :payload="
            company.resource == undefined
              ? company
              : company.resource.company
          "
        ></link-entity>
      </div>
    </div>
  </div>
</template>
<script>
import LinkEntity from '@/components/LinkEntity'
import TimeHelper from '@/custom/classes/time_helper.js'
export default {
  name: 'search-modal-companies',
  props: ['results'],
  data () {
    return {
      time_helper: new TimeHelper()
    }
  },
  components: {
    LinkEntity
  }
}
</script>
<style scoped>
  .search_result {
    cursor: auto !important;
    padding-top: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
</style>
